/**
 * @generated SignedSource<<f12f59f24ea9c77266b5b8e448f128bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useWorkspaceTodoEditRemoveImagesMutation$variables = {
  imageIds: ReadonlyArray<string>;
  todoWorkspaceId: string;
};
export type useWorkspaceTodoEditRemoveImagesMutation$data = {
  readonly todoWorkspace: {
    readonly removeImages: {
      readonly descriptionImages: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainEditedInfo_Todo">;
    };
  };
};
export type useWorkspaceTodoEditRemoveImagesMutation = {
  response: useWorkspaceTodoEditRemoveImagesMutation$data;
  variables: useWorkspaceTodoEditRemoveImagesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "imageIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoWorkspaceId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "todoWorkspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "imageIds",
    "variableName": "imageIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "descriptionImages",
  "plural": true,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkspaceTodoEditRemoveImagesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "removeImages",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceTodoEditMainEditedInfo_Todo"
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useWorkspaceTodoEditRemoveImagesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "removeImages",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aead6499590beea7641a6ace0b85aa4c",
    "id": null,
    "metadata": {},
    "name": "useWorkspaceTodoEditRemoveImagesMutation",
    "operationKind": "mutation",
    "text": "mutation useWorkspaceTodoEditRemoveImagesMutation(\n  $todoWorkspaceId: ID!\n  $imageIds: [ID!]!\n) {\n  todoWorkspace(id: $todoWorkspaceId) {\n    removeImages(imageIds: $imageIds) {\n      id\n      ...WorkspaceTodoEditMainEditedInfo_Todo\n      descriptionImages {\n        id\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceTodoEditMainEditedInfo_Todo on TodoWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "9540035400377941be11f661ecfc782e";

export default node;
